/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";

export function AppInstallAmp({ color = "#c0c0c0", pcolor = "#fff" }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 65">
      <defs />
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            className="cls-1"
            fill="none"
            stroke="#707070"
            strokeMiterlimit={10}
            strokeWidth={4}
            d="M6.43,1H33.57C36.57,1,39,3.82,39,7.3V57.7c0,3.48-2.43,6.3-5.43,6.3H6.43C3.43,64,1,61.18,1,57.7V7.3C1,3.82,3.43,1,6.43,1Z"
          />
          <circle
            className="cls-2"
            cx="20"
            cy="57.01"
            r="2.7"
            fill="none"
            strokeWidth={0.5}
            stroke="#707070"
            strokeMiterlimit={10}
          />
          <circle className="cls-3" cx="20" cy="32.5" r="14.47" fill="#e92227" />
          <rect className="cls-4" x="19.11" y="25" width="1.64" height="10.64" rx="0.52" fill="#fff" />
          <path
            className="cls-4"
            d="M19.69,36.76,14.92,32.2a.53.53,0,0,1,0-.74l.42-.43a.52.52,0,0,1,.73,0l3.59,3.43a.51.51,0,0,0,.73,0l3.43-3.58a.51.51,0,0,1,.73,0l.44.41A.53.53,0,0,1,25,32l-4.56,4.77A.53.53,0,0,1,19.69,36.76Z"
            fill="#fff"
          />
          <rect className="cls-4" x="14.55" y="38.36" width="10.91" height="1.64" rx="0.52" fill="#fff" />
          <circle className="cls-3" cx="20" cy="57.01" r="1.99" fill="#e92227" />
        </g>
      </g>
    </svg>
  );
}
AppInstallAmp.propTypes = {
  color: PropTypes.string,
  pcolor: PropTypes.string
};
